import { FC } from 'react';
import { Button } from '@mui/material';
import { PlayArrow } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface MetaPreviewSectionProps {
  isPublishedMode: boolean;
  hasSlides: boolean;
  draftId: string;
  publishedId?: string;
}

const MetaPreviewSection: FC<MetaPreviewSectionProps> = ({
  isPublishedMode,
  hasSlides,
  draftId,
  publishedId,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <Button
        disabled={!hasSlides}
        onClick={() =>
          isPublishedMode
            ? navigate(`/presentation-preview/${publishedId}`)
            : navigate(`/presentation-preview/${draftId}?isDraft=true`)
        }
        variant="outlined"
        startIcon={<PlayArrow />}
        sx={{
          height: 40,
          px: { xs: 1.25, sm: 2.75 },
          borderRadius: 2,
          bgcolor: '#f7f5ff',
          borderColor: '#ddd6fe',
          color: '#1e1b4b',
          fontWeight: 700,
          fontSize: { xs: 12.5, sm: 14 },
          textTransform: 'none',
          whiteSpace: 'nowrap',
          minWidth: 0,
          boxShadow: 'none',
          '& .MuiButton-startIcon': { mr: { xs: 0.75, sm: 1 } },
          '&:hover': {
            bgcolor: '#eeeafd',
            borderColor: '#c4b5fd',
            boxShadow: 'none',
          },
        }}
      >
        Preview {isPublishedMode ? 'Published' : 'Draft'}
      </Button>
    </>
  );
};

export default MetaPreviewSection;
